<template>
  <div class="k-col" :class="colClasses" :style="colStyle">
    <slot></slot>
  </div>
</template>
<script>
const validatorFunc = function(val) {
  return Object.keys(val).every(item => {
    return item === "span" || item === "offset";
  });
};

export default {
  name: "k-col",
  props: {
    span: {
      type: [Number, String],
      default: 24
    },
    offset: {
      type: [Number, String],
      default: 0
    },
    xs: { validator: validatorFunc },
    sm: { validator: validatorFunc },
    md: { validator: validatorFunc },
    lg: { validator: validatorFunc },
    xl: { validator: validatorFunc }
  },
  data() {
    return {
      gutter: 0
    };
  },
  computed: {
    colClasses() {
      let { span, offset, xs, sm, md, lg, xl } = this;
      return [
        ...this.createClass("", { span, offset }),
        ...this.createClass("xs-", xs),
        ...this.createClass("sm-", sm),
        ...this.createClass("md-", md),
        ...this.createClass("lg-", lg),
        ...this.createClass("xl-", xl)
      ];
    },
    colStyle() {
      let { gutter } = this;
      return `padding:0 ${gutter / 2}px`;
    }
  },
  methods: {
    createClass(deviceType, obj) {
      if (!obj) {
        return [];
      }
      let { span, offset } = obj;
      let arr = [];

      span && arr.push(`col-${deviceType}${span}`);
      offset && arr.push(`offset-${deviceType}${offset}`);

      return arr;
    }
  }
};
</script>
<style lang="less">
.k-col {
  height: auto;
  padding: 0 8px;
  box-sizing: border-box;
}

.loop-columns(@index) when (@index>0) {
  @col-prefix: col-;
  @offset-prefix: offset-;

  .@{col-prefix}@{index} {
    width: 1/24 * @index*100%;
  }

  .@{offset-prefix}@{index} {
    margin-left: 1/24 * @index*100%;
  }

  .loop-columns(@index - 1);
}

.loop-columns(24);

// xs
// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
  .loop-columns(@index) when (@index>0) {
    @col-xs-prefix: col-xs-;
    @offset-xs-prefix: offset-xs-;

    .@{col-xs-prefix}@{index} {
      width: 1/24 * @index*100%;
    }

    .@{offset-xs-prefix}@{index} {
      margin-left: 1/24 * @index*100%;
    }

    .loop-columns(@index - 1);
  }

  .loop-columns(24);
}

// sm
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) and (max-width: 767.98px) {
  .loop-columns(@index) when (@index>0) {
    @col-sm-prefix: col-sm-;
    @offset-sm-prefix: offset-sm-;

    .@{col-sm-prefix}@{index} {
      width: 1/24 * @index*100%;
    }

    .@{offset-sm-prefix}@{index} {
      margin-left: 1/24 * @index*100%;
    }

    .loop-columns(@index - 1);
  }

  .loop-columns(24);
}

// md
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) and (max-width: 991.98px) {
  .loop-columns(@index) when (@index>0) {
    @col-md-prefix: col-md-;
    @offset-md-prefix: offset-md-;

    .@{col-md-prefix}@{index} {
      width: 1/24 * @index*100%;
    }

    .@{offset-md-prefix}@{index} {
      margin-left: 1/24 * @index*100%;
    }

    .loop-columns(@index - 1);
  }

  .loop-columns(24);
}

// lg
// Large devices (desktops, 992px and up)
@media (min-width: 992px) and (max-width: 1199.98px) {
  .loop-columns(@index) when (@index>0) {
    @col-lg-prefix: col-lg-;
    @offset-lg-prefix: offset-lg-;

    .@{col-lg-prefix}@{index} {
      width: 1/24 * @index*100%;
    }

    .@{offset-lg-prefix}@{index} {
      margin-left: 1/24 * @index*100%;
    }

    .loop-columns(@index - 1);
  }

  .loop-columns(24);
}

// xl
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  .loop-columns(@index) when (@index>0) {
    @col-xl-prefix: col-xl-;
    @offset-xl-prefix: offset-xl-;

    .@{col-xl-prefix}@{index} {
      width: 1/24 * @index*100%;
    }

    .@{offset-xl-prefix}@{index} {
      margin-left: 1/24 * @index*100%;
    }

    .loop-columns(@index - 1);
  }

  .loop-columns(24);
}
</style>
